import { careerSections } from '../../../component/about/CareerData';
import { CareerPeriodType, CareerType } from '../../../shared/enum/EnumRepository';

export const CAREER_TYPE_VALUES = Object.values(CareerType) as CareerType[];

const STORAGE_RANGE_BY_TYPE = new Map<CareerType, CareerPeriodType>(
  careerSections.map(({ type, storageRange }) => [type, storageRange] as const),
);

export const getCareerPeriodType = (
  careerType: CareerType,
): CareerPeriodType => STORAGE_RANGE_BY_TYPE.get(careerType) ?? CareerPeriodType.POINT;
